/* eslint-disable no-underscore-dangle */
import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Button, Col, Avatar } from 'antd'
import { compose, withApollo } from 'react-apollo'
import moment from 'moment'
import { useHistory, withRouter } from 'react-router-dom'
import { useQuery } from '@apollo/react-hooks'

import runer from '../img/runer-silhouette-running-fast.png'
import calendar from '../img/calendar (2).png'
import call from '../img/call-answer (1).png'
import envelope from '../img/envelope.png'
import flag from '../img/flag.png'
import intersex from '../img/intersex.png'
import award from '../img/award.png'
import currentUserQuery from '../graphql/queries/currentUser'

import {
  ProfileStyled,
  RunnerStyled,
  BadgesRunnerComponents,
  ProfileNameBtnStyled,
  TextRunnerComponents,
  ProfileNameRunnerStyled,
  DataRunnerStyled,
  DataRunnerComponents,
  DataRunnertwoStyled,
  ProfileImgStyled,
  ProfileNameStyled,
  ProfileIconRunnerStyled,
} from './styled-components/profileStyled'

// import './css/profile.css'

const ProfileContainer = ({ client }) => {
  const history = useHistory()
  const { loading, data } = useQuery(currentUserQuery, { client, fetchPolicy: 'network-only' })
  console.log(loading)
  const profilePicture = useMemo(() => {
    if (!loading && data.currentUser) {
      if (data.currentUser.profile.imageUrl) {
        return (<img src={data.currentUser.profile.imageUrl} className="img-runner" alt="img-runner" />)
      }
    }
    return (<Avatar size={250} style={{ backgroundColor: '#87d068' }} icon="user" />)
  }, [data])
  if (loading) {
    return 'Loading ...'
  }
  if (!data.currentUser && !loading) {
    history.push('/login')
  }
  // console.log(data.currentUser)
  const name = `${data.currentUser.profile.firstName} ${data.currentUser.profile.lastName}`
  const birthDate = moment(data.currentUser.profile.birthDate).format('D MMM YYYY')
  const { gender } = data.currentUser.profile
  const { telephone } = data.currentUser.profile
  const { email } = data.currentUser
  const { nationality } = data.currentUser.profile
  return (
    <ProfileStyled>
      <RunnerStyled>
        <ProfileImgStyled>
          {profilePicture}
        </ProfileImgStyled>
        <Col>
          <ProfileNameBtnStyled>
            <ProfileNameStyled>
              <ProfileNameRunnerStyled className="DB-X-Li">
                {name}
              </ProfileNameRunnerStyled>
              <ProfileIconRunnerStyled>
                <img src={runer} alt="icon-name" />
              </ProfileIconRunnerStyled>
            </ProfileNameStyled>
            <Button className="btn-edit-Pro" size="large" href="/edit-profile" style={{ backgroundColor: '#f2f2f2' }}>
              <p style={{ fontSize: '25px', fontWeight: 'bold' }}>แก้ไขโปรไฟล์</p>
            </Button>
          </ProfileNameBtnStyled>
          <DataRunnerStyled>
            <DataRunnerComponents>
              <img src={calendar} className="icon-runner" alt="icon-name" />
              <TextRunnerComponents className="DB-X-Li">
                {birthDate || '00/00/00'}
              </TextRunnerComponents>
            </DataRunnerComponents>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img src={intersex} className="icon-runner" alt="icon-name" />
              <TextRunnerComponents className="DB-X-Li">
                {gender}
              </TextRunnerComponents>
            </div>
          </DataRunnerStyled>
          <DataRunnertwoStyled>
            <DataRunnerComponents>
              <img src={call} className="icon-runner" alt="icon-name" />
              <TextRunnerComponents className="DB-X-Li">
                {telephone || '-'}
              </TextRunnerComponents>
            </DataRunnerComponents>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img src={envelope} className="icon-runner" alt="icon-name" />
              <TextRunnerComponents className="DB-X-Li">
                {email}
              </TextRunnerComponents>
            </div>
          </DataRunnertwoStyled>
          <DataRunnertwoStyled>
            <DataRunnerComponents>
              <img src={flag} className="icon-runner" alt="icon-name" />
              <TextRunnerComponents className="DB-X-Li">
                {nationality || '-'}
              </TextRunnerComponents>
            </DataRunnerComponents>
          </DataRunnertwoStyled>
          <DataRunnertwoStyled>
            <BadgesRunnerComponents className="Badges-runner">
              E-Badges
            </BadgesRunnerComponents>
            <div>
              <img src={award} className="icon-Badges-runner" alt="icon-name" />
            </div>
          </DataRunnertwoStyled>
          <div style={{ textAlign: 'left' }}>
            <p className="text-badges-runner">2 Medal</p>
          </div>
        </Col>
      </RunnerStyled>
    </ProfileStyled>
  )
}
ProfileContainer.propTypes = {
  client: PropTypes.shape().isRequired,
}

export default compose(withApollo, withRouter)(ProfileContainer)



// WEBPACK FOOTER //
// ./src/components/profile.js